import financialOperationsServices from '@/api/financialOperationsServices';
import { RootState } from '@/app/store';
import { BulkTransactions } from '@/interfaces/financialOperations';
import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

interface BulkTrState {
  value: { [key: string]: BulkTransactions[] };
  currFilters: string;
  loading: boolean;
  error: string;
  firstLoading: boolean;
}

const initialState: BulkTrState = {
  value: {},
  currFilters: '',
  loading: false,
  error: '',
  firstLoading: true,
};

export const fetchBulkTransactions = createAsyncThunk('bulkTransactions/operations', async ({ filters = {} }: { filters?: any }) => {
  const result = await financialOperationsServices.bulkFinancialOperations({ ...filters });
  return result;
});

export const fetchMyBulkTransactions = createAsyncThunk('myBulkTransactions/operations', async ({ filters = {} }: { filters?: any }) => {
  const result = await financialOperationsServices.myBulkFinancialOperations({ ...filters });
  return result;
});

export const bulkTransactionsSlice = createSlice({
  name: 'bulkTransactions',
  initialState,
  reducers: {
    refresh: () => initialState,
    refreshTr: state => {
      state.value = {};
    },
    handleParamsChange: (state, action: PayloadAction<{ accountId: string; approve: boolean }>) => {
      const filters = JSON.stringify(action.payload);
      state.currFilters = filters;
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchBulkTransactions.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchBulkTransactions.fulfilled, (state, action) => {
      const {
        payload: { data },
      } = action;
      state.value[state.currFilters] = data;
      state.loading = false;
      state.firstLoading = false;
    });
    builder.addCase(fetchBulkTransactions.rejected, state => {
      state.loading = false;
      state.error = 'Error';
      state.firstLoading = false;
    });
    builder.addCase(fetchMyBulkTransactions.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchMyBulkTransactions.fulfilled, (state, action) => {
      const {
        payload: { data },
      } = action;
      state.value[state.currFilters] = data;
      state.loading = false;
      state.firstLoading = false;
    });
    builder.addCase(fetchMyBulkTransactions.rejected, state => {
      state.loading = false;
      state.error = 'Error';
      state.firstLoading = false;
    });
  },
});

export const { handleParamsChange, refreshTr, refresh } = bulkTransactionsSlice.actions;

export const bulkTransactions = (state: RootState) => state.bulkTransactions;

export default bulkTransactionsSlice.reducer;
